import React from 'react'

import { SxProps } from '@mui/material'

import Box from 'components_new/atoms/Box'
import Skeleton from 'components_new/atoms/Skeleton'

import ThumbnailList from 'components_new/molecules/ThumbnailList'

interface Props {
  sx?: SxProps
}

const Loading = (props: Props) => {
  const { sx } = props

  return (
    <Box sx={sx}>
      <ThumbnailList
        itemSize={{
          xs: 12,
          md: 12,
          lg: 12,
          xl: 12
        }}
      >
        {[1, 2, 3].map((item) => (
          <Skeleton key={item} variant="rounded" width={'100%'} height={100} />
        ))}
      </ThumbnailList>
    </Box>
  )
}

Loading.displayName = 'Loading'

export default Loading
